<template>
  <BaseButton
    :type="props.type"
    class="text-primary bg-white border border-primary hover:bg-gray-100 focus:z-10"
    :class="props.class"
    :disabled="props.disabled"
  >
    <slot />
  </BaseButton>
</template>
<script setup>
import BaseButton from './BaseButton.vue';

const props = defineProps({
  class: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'button',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});
</script>
